module.exports = __webpack_public_path__ + "static/media/directory.9001ad55.svg";